export const choiceDialogName = 'choiceDialogComponent';
